import { Link } from "components/Link";
import { SrcSet } from "components/SrcSet";
import { useState } from "react";
import styles from "./PeopleList.module.css";

export const PeopleListWrapper = ({ people, filters, type }) => {
  const formattedPeople = [...people]
    .map((person) => {
      const {
        uid,
        data: { image, job_title, name, region, type, types, city },
      } = person;
      return {
        city,
        image: { src: image.url, alt: image.alt },
        jobTitle: job_title,
        name,
        region,
        type: [type, ...(types || []).map(({ type }) => type)].filter(Boolean),
        uid,
        link: person,
      };
    })
    .sort((a, b) => (a.name > b.name ? 1 : -1));

  return (
    <PeopleList people={formattedPeople} filterKeys={filters} docType={type} />
  );
};

export const PeopleList = ({ people, filterKeys = {}, docType }) => {
  const [filters, setFilters] = useState(
    Object.keys(filterKeys).reduce((acc, cur) => ({ ...acc, [cur]: "" }), {})
  );

  const filteredPeople = people.filter(
    (person) =>
      Object.entries(filters)
        .map(
          ([key, value]) =>
            value === "" ||
            person[key] === value ||
            person[key].indexOf(value) > -1
        )
        .filter((x) => x === false).length === 0
  );

  return (
    <div>
      {Object.keys(filterKeys).length > 0 && (
        <div className={styles.listHeader}>
          {Object.entries(filterKeys).map(([key, value]) => (
            <PeopleListSelect
              allLabel={value}
              key={key}
              onChange={(value) => setFilters({ ...filters, [key]: value })}
              options={getUniqueValuesForKey(people, key)}
            />
          ))}
        </div>
      )}
      <div>
        {filteredPeople.map((person) => (
          <PeopleCard key={person.uid} docType={docType} {...person} />
        ))}
      </div>
    </div>
  );
};

const PeopleCard = ({ city, image, jobTitle, name, region, docType, link }) => {
  const type = docType.replace("_overview", "_detail");

  return (
    <Link className={styles.card} field={link}>
      {image.src && (
        <SrcSet
          className={styles.image}
          alt={image.alt}
          src={image.src}
          sizes={[
            { ratio: 1, minWidth: 1024, width: 96 },
            { ratio: 1, minWidth: 1, width: 72 },
          ]}
        />
      )}
      <div>
        <h3 className={styles.name}>{name}</h3>
        <div className={styles.title}>{jobTitle}</div>
        {city && region && (
          <div className={styles.meta}>
            {city} • {region}
          </div>
        )}
      </div>
    </Link>
  );
};

const PeopleListSelect = ({ options, onChange, allLabel }) => (
  <div className={styles.selectContainer}>
    <select
      className={styles.select}
      onChange={(e) => onChange(e.target.value)}
    >
      <option value="">{allLabel}</option>
      {options.map((o) => (
        <option key={o}>{o}</option>
      ))}
    </select>
    <div className={styles.selectArrow} />
  </div>
);

function getUniqueValuesForKey(array, key) {
  return array
    .map((o) => o[key])
    .reduce((acc, cur) => [...acc, cur].flat(), [])
    .filter((value, index, self) => self.indexOf(value) === index)
    .sort((a, b) => (a > b ? 1 : -1));
}
